// extracted by mini-css-extract-plugin
export default {"MainContent":"Blank_MainContent__+mqop"};